var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconSeat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-706.000000, -58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "silla-libre",
    transform: "translate(721.000000, 73.000000) rotate(-90.000000) translate(-721.000000, -73.000000) translate(706.000000, 60.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.98058068,1.19611614 L20.9805807,4.19611614 C23.3177017,4.66354033 25,6.71561441 25,9.09901951 L25,15.9009805 C25,18.2843856 23.3177017,20.3364597 20.9805807,20.8038839 L5.98058068,23.8038839 C3.27278191,24.3454436 0.638656375,22.5893599 0.0970966215,19.8815612 C0.0325234372,19.5586952 4.03227115e-17,19.2302404 0,18.9009805 L0,6.09901951 C-3.38176876e-16,3.33759576 2.23857625,1.09901951 5,1.09901951 C5.32925993,1.09901951 5.65771475,1.13154295 5.98058068,1.19611614 Z",
    id: "seat",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "backrest",
    x: 25,
    y: 0,
    width: 5,
    height: 25,
    rx: 2.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeat);
export default __webpack_public_path__ + "static/media/iconSeat.1986d32005069f4382e58beaa62a1d3e.svg";
export { ForwardRef as ReactComponent };